/* eslint-disable jsx-a11y/aria-role */
import { h, Fragment } from 'preact'
import { bem, createUniqueId } from '@nrk/dh-utils'
import { Message } from '../../../../../lib/intl/Message'
import { TableHeaderCell, TableCell } from '../../Oppslutning/shared/Table'

/* styles */
import tableStyles from '../../Oppslutning/shared/Table.css'

export function calculateBarWidthPercent(percent: number, maxPercent: number = 0): number {
  if (isNaN(percent) || maxPercent <= 0) {
    return 0
  }
  return (percent * 100) / maxPercent
}

type Props = {
  type: 'steder' | 'partier'
  minimumShowing: number
  toggleShowMore: () => void
}

export function OppslutningLoadingTable(props: Props) {
  const selector = createUniqueId()
  const { minimumShowing, type } = props

  const hasAntall = true
  const maksProsent = 45
  const hasMore = false
  const items = [45, 40, 30, 17, 8, 6, 4]
  const farge = '#e9e9e9'

  return (
    <Fragment>
      <div
        data-expand-selector={selector}
        class={bem(tableStyles.table, { hasMore })}
        style={{ '--expand-start': Math.min(items.length, minimumShowing), color: '#989898' }}
      >
        <TableHeaderCell index={0} modifier="parti">
          {type === 'partier' ? (
            <Message id="oppslutning-parti" />
          ) : (
            <Message id="oppslutning-sted" />
          )}
        </TableHeaderCell>
        <TableHeaderCell index={0} modifier="bar" />
        <TableHeaderCell index={0} modifier="oppslutning">
          <Message id="oppslutning-prosent" />
        </TableHeaderCell>
        {hasAntall ? (
          <TableHeaderCell index={0} modifier="antall">
            <Message id="oppslutning-antall" />
          </TableHeaderCell>
        ) : null}

        {items.map((item, idx) => {
          const index = idx + 1
          const style = { '--item-index': index }
          const width = calculateBarWidthPercent(item, maksProsent)
          const isHidden = index > minimumShowing

          return (
            <Fragment key={index}>
              <TableCell index={index} modifiers={['parti']} isHidden={isHidden} style={style}>
                <div class={tableStyles.table__bar} style={{ width: '40%', background: farge }} />
              </TableCell>
              <TableCell
                index={index}
                modifiers={['bar']}
                isHidden={isHidden}
                style={style}
                aria-hidden="true"
              >
                <div
                  class={tableStyles.table__bar}
                  style={{ width: width + '%', background: farge }}
                />
              </TableCell>
              <TableCell
                index={index}
                modifiers={['oppslutning']}
                isHidden={isHidden}
                style={style}
                role="text"
              />
              {hasAntall ? (
                <TableCell
                  index={index}
                  modifiers={['antall']}
                  isHidden={isHidden}
                  style={style}
                  role="text"
                />
              ) : null}
            </Fragment>
          )
        })}
      </div>
    </Fragment>
  )
}
